import React, { Component } from "react";
import { ReactBnbGallery } from "react-bnb-gallery";
import axios from "axios";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { TIcon3, Icon1, Icon2 } from "../../assets";
import GoogleMapReact from "google-map-react";
import { OrangePin } from "../../assets";
import { withStyles } from "@material-ui/core/styles";
import "../../assets/css/componentSpecificCss/kidspreview.css";
import GeoCode from "react-geocode";
import {
  Outdoors,
  Faith,
  Arts,
  Mixed,
  Athletics,
  STEM,
  Theatre,
  Creative,
  Dance,
  Exercise,
  SpecialNeeds,
  LanguageCulture,
  Drama,
  DaycarePreschool,
  Camps,
  Music,
  Cooking,
  AfterSchool,
  Academics,
  Leadership,
  Playgrounds,
  Tutoring,
  LifeSkills
} from "../../assets";
const styles = {
  plan: {
    transition: "all 300ms",
    "&:hover": {
      transform: "scale(1.001) translateY(-3px)",
      boxShadow: "0 2px 15px 0 rgba(204,204,204,0.5)"
    }
  },
  planSelected: {
    transform: "scale(1.02) translateY(-3px)",
    boxShadow: "0 7px 12px 0 rgba(0,0,0,.3)"
  },
  tabRoot: {
    color: "gray !important",
    fontFamily: "Montserrat,sans-serif !important",
    fontWeight: "400 !important",
    fontSize: "1.1rem !important",
    "&:hover": {
      backgroundColor: "transparent !important",
      color: "gray !important"
    },
    "&:focus": {
      backgroundColor: "transparent !important",
      color: "gray !important"
    }
  },
  tabSelected: {
    color: "black !important",
    "&:hover": {
      backgroundColor: "transparent !important",
      color: "black !important"
    },
    "&:focus": {
      backgroundColor: "transparent !important",
      color: "black !important"
    }
  },
  tabIndicator: {
    backgroundColor: "#ff6663",
    height: "3px",
    marginTop: "20px"
  },
  input: {
    height: "3em",
    border: "1px solid #E8E8E8",
    borderRadius: "3px",
    fontFamily: "Montserrat, sans-serif !important",
    paddingLeft: "0.5em"
  },
  textArea: {
    height: "6em",
    border: "1px solid #E8E8E8",
    borderRadius: "3px",
    fontFamily: "Montserrat, sans-serif !important",
    paddingLeft: "0.5em"
  },
  datePicker: {
    height: "3em",
    border: "1px solid #E8E8E8",
    width: "100%",
    borderRadius: "3px",
    fontFamily: "Montserrat, sans-serif !important",
    paddingLeft: "0.5em"
  },
  tabsHeadings: {
    height: "50px",
    minHeight: "40px",
    paddingLeft: "15px",
    borderTop: "1px solid gainsboro",
    borderBottom: "1px solid gainsboro"
  },
  subHeadings: {
    paddingLeft: "17px",
    display: "flex",
    alignItems: "center",
    "& .MuiTabs-flexContainer": {
      height: "50px"
    },
    "& .PreviewPartner-tabIndicator-5": {
      backgroundColor: "black"
    }
  }
};

GeoCode.setRegion("ca");
GeoCode.setLanguage("en");
GeoCode.setApiKey("");
class PreviewKids extends Component {
  constructor(props) {
    super(props);
    this.sortDays = {
      Monday: 0,
      Tuesday: 1,
      Wednesday: 2,
      Thursday: 3,
      Friday: 4,
      Saturday: 5,
      Sunday: 6
    };
    this.state = {
      galleryShown: false,
      active: "Programs",
      description: "",
      covid19: "",
      hours: [-1, -1],
      article: null,
      data: { target_ages: [], program_types: [], gallery: [] },
      events: [],
      memberships: [],
      programs: [],
      parties: [],
      other_locations: [],
      Registration: {},
      main_tags: [],
      gifts: [],
      tags: [],
      gallery: [],
      news: [],
      forms: [],
      // displayDays: [],
      expandOperationHours: false,
      image_gifts: [
        "partners/Gift Cards/zeus-01.png",
        "partners/Gift Cards/zeus-02.png",
        "partners/Gift Cards/zeus-03.png",
        "partners/Gift Cards/zeus-04.png",
        "partners/Gift Cards/zeus-05.png",
        "partners/Gift Cards/zeus-06.png",
        "partners/Gift Cards/zeus-07.png",
        "partners/Gift Cards/zeus-08.png"
      ],
      formData: {},
      selectedForm: 0,
      selectedProgram: 0,
      sublinks: {
        Programs: [
          "Recurring",
          "Semester",
          "Camps",
          "Workshops",
          "Classes",
          "Online Virtual"
        ],
        Forms: [
          "Registration",
          "Applications",
          "Appointments",
          "Waitlists",
          "Contact Us"
        ]
      }
    };
  }
  setIcons() {
    const st = this.state;

    // {
    //   icon:
    //     "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/megaphone.png",
    //   title: "Operating Days",
    //   content: `${
    //     st.days_of_week
    //       ? Object.keys(st.days_of_week)
    //           .sort((a, b) => (this.sortDays[a] > this.sortDays[b] ? 1 : -1))
    //           .join(", ")
    //       : "--"
    //   }`
    // },
    return [
      {
        icon: "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/megaphone.png",
        title: "Reopening Plan",
        content: `${this.state.reopening}`
      },
      {
        icon: "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/graph.png",
        title: "Category",
        content: `${st.program_structures}`
      },
      {
        icon: "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/browser.png",
        title: "Website",
        content: `${st.website}`,
        hide: true
      },
      // {
      //   icon:
      //     "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/clock.png",
      //   title: "Hours",
      //   content:
      //     st.hours[0] === -1
      //       ? "--"
      //       : `${parseInt(st.hours[0] < 13 ? st.hours[0] : st.hours[0] - 12)}:${
      //           st.hours[0] / parseInt(st.hours[0]) > 1 ? "30" : "00"
      //         } ${st.hours[0] < 11.5 ? "A.M." : "P.M."} - ${parseInt(
      //           st.hours[1] < 13 ? st.hours[1] : st.hours[1] - 12
      //         )}:${st.hours[1] / parseInt(st.hours[1]) > 1 ? "30" : "00"} ${
      //           st.hours[1] > 11.5 ? "P.M." : "A.M."
      //         }`
      // },
      {
        icon: "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/printer.png",
        title: "Format",
        content: `${st.format}`
      },
      {
        icon: "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/smart-watch.png",
        title: "Phone",
        content: `${st.phone1}`,
        hide: true
      },
      {
        icon: "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/theatre.png",
        title: "Age Range",
        content: `${st.age_range}`
      },
      {
        icon: "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/map-.png",
        title: "Locations",
        content: 1 + this.state.other_locations.length
      },
      {
        icon: "https://dreamschools-files.s3.us-east-2.amazonaws.com/partners/Icons/letter.png",
        title: "Email",
        content: `${st.email}`,
        hide: true
      }
    ];
  }
  async componentDidMount() {
    const preview = this.props.match.params.preview || false;
    const slug = this.props.match.params.slug;
    const ep = `${process.env.REACT_APP_API}/frnt/program/kidget/${slug}/${preview}`;
    const res = await axios.get(ep);

    if (res.data.success) {
      // const days = Object.keys(res.data.data.days_of_week);
      // const DaysOfWeek = ['Monday', "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].filter(e => e == days.filter(f => f == e)[0]);
      this.setState({
        ...res.data.data
        // displayDays: DaysOfWeek
      });
    }
  }

  displayHours = (fromHours, toHours) => {
    if (fromHours === -1) {
      return "-";
    } else {
      return (
        <div>
          {parseInt(fromHours) > 12
            ? parseInt(fromHours) - 12
            : parseInt(fromHours)}
          :{fromHours / parseInt(fromHours) > 1 ? "30" : "00"}{" "}
          {fromHours < 11.5 ? "AM" : "PM"} -{" "}
          {parseInt(toHours) > 12 ? parseInt(toHours) - 12 : parseInt(toHours)}:
          {toHours / parseInt(toHours) > 1 ? "30" : "00"}{" "}
          {toHours > 11.5 ? "PM" : "AM"}
        </div>
      );
    }
  };

  render() {
    if (!this.state.days_of_week) {
      return null;
    }
    const { slug } = this.props.match.params;
    const photoMatch = {
      Outdoors: Outdoors,
      Faith: Faith,
      Arts: Arts,
      Music: Music,
      Mixed: Mixed,
      Athletics: Athletics,
      STEM: STEM,
      Theatre: Theatre,
      Creative: Creative,
      Dance: Dance,
      Leadership: Leadership,
      "Life Skills": LifeSkills,
      Exercise: Exercise,
      "After School": AfterSchool,
      "Before & After School": AfterSchool,
      Academics,
      "Special Needs": SpecialNeeds,
      Drama: Drama,
      Camps,
      Cooking,
      "Daycare / Preschool": DaycarePreschool,
      "Language / Culture": LanguageCulture,
      Playgrounds,
      Tutoring
    };
    return (
      <>
        <ReactBnbGallery
          show={this.state.galleryShown}
          photos={this.state.gallery.map(
            e => `${process.env.REACT_APP_DS_FILES_S3 + "/" + e}`
          )}
          onClose={_ => this.setState({ galleryShown: false })}
        />

        <div
          className="container-fluid header-img"
          style={{
            backgroundImage: `url(https://dreamschools-files.s3-us-east-2.amazonaws.com/partners/Banners/Banner3.jpg)`,
            backgroundPosition: "50%",
            backgroundBlendMode: "multiply",
            backgroundSize: "cover",
            backgroundColor: "rgba(0,0,255,.2)"
          }}
        ></div>

        <div className="content-area-kids">
          {/*Header Portion */}

          <div className="top-content-kids">
            <div className="content-display-kids">
              <div className="left-content-kids">
                <div className="previewdivs">
                  <div>
                    <h2
                      className="title-kids"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {this.state.organization}{" "}
                    </h2>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between"
                      }}
                    >
                      <div className="verification-container">
                        <span className="spanview">
                          {this.state.isLive
                            ? "Verified"
                            : "Verification Pending"}
                        </span>
                      </div>

                      <div className="icon-btns">
                        {this.state.twitter && (
                          <div className="button-list">
                            <div
                              className="twitterbcg"
                              onClick={_ =>
                                window.open(
                                  this.state.twitter.includes("http://") ||
                                    this.state.twitter.includes("https://")
                                    ? this.state.twitter
                                    : "http://" + this.state.twitter,
                                  "_blank"
                                )
                              }
                            ></div>
                          </div>
                        )}
                        {this.state.instagram && (
                          <div className="button-list">
                            <div
                              className="igbcg"
                              onClick={_ =>
                                window.open(
                                  this.state.instagram.includes("http://") ||
                                    this.state.instagram.includes("https://")
                                    ? this.state.instagram
                                    : "http://" + this.state.instagram,
                                  "_blank"
                                )
                              }
                            ></div>
                          </div>
                        )}
                        {this.state.facebook && (
                          <div className="button-list">
                            <div
                              className="fbbcg"
                              onClick={_ =>
                                window.open(
                                  this.state.facebook.includes("http://") ||
                                    this.state.facebook.includes("https://")
                                    ? this.state.facebook
                                    : "http://" + this.state.facebook,
                                  "_blank"
                                )
                              }
                            ></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-area-kids">
                  <div>
                    <p className="text-description">
                      {this.state.data.description}
                    </p>

                    <div className="data display-icons-kids">
                      {/* Time Open */}
                      {this.setIcons().map((e, i) => (
                        <div className="box icon-containers-kids" key={i}>
                          <img
                            src={e.icon}
                            alt="Icon"
                            className="icon-img-kids"
                          />
                          <div className="alignement">
                            <p className="icon-name-kids">
                              <b>{e.title}</b>
                            </p>
                            <p
                              className="icon-inner-text-kids"
                              style={{
                                wordBreak:
                                  e.title === "Website" ? "break-all" : "normal"
                              }}
                            >
                              {e.hide && !this.state[e.title] ? (
                                <a
                                  onClick={_ =>
                                    this.setState({ [e.title]: true })
                                  }
                                  href="#\"
                                >
                                  Click to view
                                </a>
                              ) : (
                                e.content
                              )}
                            </p>
                          </div>
                        </div>
                      ))}

                      {/* Target Ages */}

                      {/* Gallery */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Google Map */}
              <div className="map-container-kids">
                <img
                  src={
                    photoMatch[this.state.image] ||
                    `${process.env.REACT_APP_DS_FILES_S3}/${this.state.image}`
                  }
                  alt="Program Cover"
                  style={{
                    width: "100%",
                    height: "250px",
                    objectFit: "cover"
                  }}
                ></img>

                <div className="littlemarg">
                  {this.state.main_tags.map(e => {
                    const element = typeof e === "string" ? JSON.parse(e) : e;
                    return <span className="tag">{element.name}</span>;
                  })}
                  {this.state.tags.map(e => {
                    const element = typeof e === "string" ? JSON.parse(e) : e;
                    return <span className="tag">{element.name}</span>;
                  })}
                </div>

                <div
                  className={
                    this.state.expandOperationHours
                      ? "open-hours-container-expanded"
                      : "open-hours-container-contained"
                  }
                >
                  <div className="open-hours">
                    <div className="open-hours-title">
                      <i
                        className="far fa-clock"
                        style={{ marginRight: "10px" }}
                      ></i>{" "}
                      Hours of Operation (click here)
                    </div>

                    {this.state.expandOperationHours &&
                      this.state.operational_days.map(e => {
                        const ele = typeof e === "string" ? JSON.parse(e) : e;

                        return (
                          <div className="week-timings">
                            <div className="daily-timings">
                              <strong className="days-of-week">
                                {ele.day}
                              </strong>
                              <span className="days-timings">
                                {this.displayHours(ele.fromHours, ele.toHours)}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                  </div>

                  <div
                    className="show-hours-btn"
                    onClick={_ =>
                      this.setState({
                        expandOperationHours: !this.state.expandOperationHours
                      })
                    }
                  >
                    {this.state.expandOperationHours ? (
                      <i
                        className="fas fa-chevron-up"
                        style={{ color: "#bcbcbc", fontSize: "12px" }}
                      ></i>
                    ) : (
                      <i
                        className="fas fa-chevron-down"
                        style={{ color: "#bcbcbc", fontSize: "12px" }}
                      ></i>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content-area-kids">
          <div className="top-content-kids">
            <div className="content-display-kids" style={{ display: "block" }}>
              <div className="left-content-kids">
                <div
                  // className="content-display-no-flex"
                  style={{ display: "block" }}
                >
                  {/* <div
                className="left-content-kids"
                style={{ flexGrow: 1, width: "100%" }}
              > */}
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center"
                    }}
                  >
                    <h3 className="sub-title">ABOUT OUR PROGRAM</h3>
                    <img
                      src="data:image/png;base64,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"
                      alt=""
                      style={{ height: "33px", marginLeft: "30px" }}
                    ></img>
                  </div>
                  {this.state.description.split("\n").map(e => (
                    <p style={{ fontFamily: "Open Sans, sans-serif" }}>{e}</p>
                  ))}
                  {/* </div> */}
                  {this.state.covid19 && (
                    <div
                      // className="left-content-kids"
                      style={{ flexGrow: 1, marginTop: "30px", width: "100%" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center"
                        }}
                      >
                        <h3 className="sub-title">RE-OPENING MEASURES</h3>
                        <img
                          src="data:image/png;base64,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"
                          alt=""
                          style={{ height: "33px", marginLeft: "30px" }}
                        />
                      </div>
                      {this.state.covid19.split("\n").map(e => (
                        <p style={{ fontFamily: "Open Sans, sans-serif" }}>
                          {e}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="map-container-kids">
                <div className="galwdt">
                  <h3
                    style={{
                      margin: 0,
                      textAlign: "left",
                      marginBottom: "5px"
                    }}
                    className="sub-title"
                  >
                    Gallery
                  </h3>
                  <div className="d-flex" style={{ flexWrap: "wrap" }}>
                    {this.state.gallery.map((e, index) => (
                      <div
                        style={{
                          width: `calc(33% - 10px)`,
                          marginBottom: "10px"
                        }}
                      >
                        <div
                          onClick={_ => this.setState({ galleryShown: true })}
                          className="new-gallery-img"
                          style={{
                            backgroundImage: `url(${process.env.REACT_APP_DS_FILES_S3}/${e})`,
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            transform: `rotate(${
                              this.state[`gallery_image_${index}`]
                            }deg)`
                          }}
                        />
                        {/* <img
                          className="gal-image"
                          style={{
                            width: "90%",
                            minWidth: "unset",
                            minHeight: "unset",
                            maxWidth: "unset",
                            maxHeight: "unset"
                          }}
                          src={`${process.env.REACT_APP_DS_FILES_S3}/${e}`}
                          onClick={_ => this.setState({ galleryShown: true })}
                        /> */}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content-area-kids">
          <div className="top-content-kids">
            <div className="content-display-kids" style={{ display: "block" }}>
              <div
                style={{ height: "250px", width: "100%", marginBottom: "6em" }}
              >
                {this.state.lat && (
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: "AIzaSyDVNuWNguQz4vB25OdDpztwxE3QR_CzG0g"
                    }}
                    defaultZoom={9}
                    defaultCenter={{
                      lat: parseFloat(this.state.lat),
                      lng: parseFloat(this.state.long)
                    }} // Default toronto lat: 43.695572, lng: -79.415605
                    options={{ gestureHandling: "greedy" }}
                  >
                    <div
                      lat={this.state.lat}
                      lng={this.state.long}
                      style={{
                        backgroundImage: `url(${OrangePin})`,
                        backgroundSize: "cover",
                        height: 30,
                        width: 22,
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                        bottom: 15,
                        right: 15
                      }}
                    ></div>
                    {this.state.other_locations.map(e => (
                      <div
                        lat={e.lat}
                        lng={e.lng}
                        style={{
                          backgroundImage: `url(${OrangePin})`,
                          backgroundSize: "cover",
                          height: 30,
                          width: 22,
                          cursor: "pointer",
                          zIndex: 10,
                          position: "relative",
                          bottom: 15,
                          right: 15
                        }}
                      ></div>
                    ))}
                  </GoogleMapReact>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(PreviewKids);
